<div class="modal-header">
  <h4 class="modal-title">Asignar Menú</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ngx-treeview [config]="config" [items]="items" (selectedChange)="onSelectedChange($event)">
  </ngx-treeview>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-danger" (click)="Cancelar()">Cancelar</button>
  <button type="button" class="btn btn-outline-primary" (click)="Aceptar()"
  [disabled]="menuId.length === 0">Aceptar</button>
</div>
